module.exports = __webpack_public_path__ + "img/icon-success.35bcc15b.png";